module.exports = __webpack_public_path__ + "img/qbert_questions_p16.32b18cc7.jpg";